import { render } from "./StepThree.vue?vue&type=template&id=00fbaace"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"
script.render = render

export default script